export const getLanguageCode = (languageName: string | null | undefined): string => {
  if (!languageName) return '';
  const lowerLang = languageName.toLowerCase();
  switch (lowerLang) {
    case 'english':
      return 'en';
    case 'greek':
      return 'el';
    case 'french':
      return 'fr';
    case 'spanish':
      return 'es';
    case 'german':
      return 'de';
    case 'italian':
      return 'it';
    // Add more languages as needed
    default:
      // Return the first two letters of the language name as a fallback, or the full name if it's shorter
      return languageName.substring(0, 2).toLowerCase(); 
  }
};

export const getFullLanguageName = (languageCode: string | null | undefined): string => {
  if (!languageCode) return '';
  const lowerCode = languageCode.toLowerCase();
  switch (lowerCode) {
    case 'en':
      return 'English';
    case 'el':
      return 'Greek';
    case 'fr':
      return 'French';
    case 'es':
      return 'Spanish';
    case 'de':
      return 'German';
    case 'it':
      return 'Italian';
    default:
      return languageCode.toUpperCase(); // Fallback for unknown codes
  }
};

// You might want a more comprehensive list for a select dropdown
export const commonLanguages: { code: string; name: string }[] = [
  { code: 'en', name: 'English' },
  { code: 'el', name: 'Greek' },
  { code: 'fr', name: 'French' },
  { code: 'es', name: 'Spanish' },
  { code: 'de', name: 'German' },
  { code: 'it', name: 'Italian' },
  // Add other common languages
]; 